angular
  .module('examManagement')
  .factory('Selectors::ExamQuestionGroupList', function () {
    function getItems(object) {
      switch (object.examQuestionGroupList.scrambling) {
        case 'A':
          return object.examQuestionGroupList.bookletA
            ? object.examQuestionGroupList.bookletA.exam_question_groups
            : [];
        case 'B':
          return object.examQuestionGroupList.bookletB
            ? object.examQuestionGroupList.bookletB.exam_question_groups
            : [];
        default:
          return [];
      }
    }

    function transformToFlatItems(items, scrambling) {
      if (!items || items.length === 0) {
        return [];
      }

      const firstItem = items[0];
      const firstPosition =
        scrambling === 'A' ? firstItem.position_a : firstItem.position_b;
      const isZeroBased = firstPosition === 0;
      const fixedLookup = items.reduce((acc, eqg) => {
        acc[eqg.question_group.sequential_number] = createFixedNumbers(
          eqg.question_group.questions,
          eqg.position_a,
          isZeroBased
        );

        return acc;
      }, {});

      return items.map(item => {
        const { question_group } = item;
        const questions = question_group.questions || [];
        const future_exams = question_group.future_exams || [];

        return {
          ...item,
          question_group: {
            ...question_group,
            literary_reference: truncate(
              questions.map(question => question.literary_reference).join(', ')
            ),
            question_types: questions
              .map(question => I18n.t(`questions.type.${question.type}`))
              .join(', '),
            fixed_numbers: fixedLookup[question_group.sequential_number],
            score: questions.reduce((acc, question) => acc + question.score, 0),
            future_exam_names: future_exams.map(exam => exam.name).join(', ')
          }
        };
      });
    }

    const typeKeys = {
      A: 'A',
      'A-': 'A',
      E: 'E',
      Essay: 'T',
      LongMenu: 'L',
      Kprime: 'K'
    };

    function createFixedNumbers(questions, positionA, isZeroBased) {
      let normalizedPosA = positionA;

      if (isZeroBased) {
        normalizedPosA++;
      }

      const qgPosition = normalizedPosA.toString().padStart(3, '0');

      return questions
        .map((question, i) => {
          const questionPosition = (i + 1).toString().padStart(2, '0');
          const type = question.type ? typeKeys[question.type] : '';

          return `${qgPosition}-${questionPosition}-${type}`;
        })
        .join('\n');
    }

    function truncate(string) {
      if (string.length > 20) {
        return string.substr(0, 20) + '...';
      } else {
        return string;
      }
    }

    function extractQuestionGroups(items) {
      return items.filter(function (item) {
        return item.question_group.type !== 'SINGLE';
      });
    }

    function getColumnDefinitions(object) {
      return (
        object &&
        object.examQuestionGroupList &&
        object.examQuestionGroupList.columns
      );
    }

    function getScrambling(object) {
      return (
        object &&
        object.examQuestionGroupList &&
        object.examQuestionGroupList.scrambling
      );
    }

    function transformToArray(columns) {
      return Object.keys(columns).reduce(function (acc, columnName) {
        acc.push(Object.assign({ name: columnName }, columns[columnName]));
        return acc;
      }, []);
    }

    function extractColumnVisibilities(columns) {
      return Object.keys(columns).reduce(function (acc, column) {
        acc[column] = columns[column] && columns[column].visible;
        return acc;
      }, {});
    }

    function getSelection(object) {
      return (
        object &&
        object.examQuestionGroupList &&
        object.examQuestionGroupList.selection
      );
    }

    function getQuestionGroup(selection, items) {
      var item = extractSelectedItem(selection, items);
      return item && item.question_group;
    }

    function extractSelectedItem(selection, items) {
      return items.find(function (item) {
        return item.id == selection;
      });
    }

    function getTotalScore(object) {
      return (getItems(object) || []).reduce(function (acc, examQuestionGroup) {
        var score = examQuestionGroup.question_group.questions.reduce(function (
          acc,
          question
        ) {
          return acc + question.score;
        },
        0);

        return acc + score;
      }, 0);
    }

    function isRequestInProgress(object) {
      return (
        (object &&
          object.examQuestionGroupList &&
          object.examQuestionGroupList.requestInProgress) ||
        false
      );
    }

    function getStats(object) {
      var items = getItems(object);
      var numberOfQuestionGroups = extractQuestionGroups(items).length;
      var numberOfSingleQuestions = items.length - numberOfQuestionGroups;

      return {
        numberOfSingleQuestions: numberOfSingleQuestions,
        numberOfQuestionGroups: numberOfQuestionGroups,
        totalScore: getTotalScore(object)
      };
    }

    return {
      getColumnDefinitions: getColumnDefinitions,
      getColumnDefinitionsAsArray: Reselect.createSelector(
        getColumnDefinitions,
        transformToArray
      ),
      getColumnVisibilities: Reselect.createSelector(
        getColumnDefinitions,
        extractColumnVisibilities
      ),
      getSelection: getSelection,
      getSelectedQuestionGroup: Reselect.createSelector(
        getSelection,
        getItems,
        getQuestionGroup
      ),
      getItems: getItems,
      getFlatItems: Reselect.createSelector(
        getItems,
        getScrambling,
        transformToFlatItems
      ),
      getStats: getStats,
      isRequestInProgress: isRequestInProgress,
      getSelectedItem: Reselect.createSelector(
        getSelection,
        getItems,
        extractSelectedItem
      ),
      getScrambling: getScrambling
    };
  });
